module.exports = __webpack_public_path__ + "static/media/proj1_img1.44d2da36.jpg";